
<template>
  <div class="filter">
    <div id="overlay-filters" class="overlay-filter" v-if="props.isActive" @click="(e)=>emit('toggleMenu',e)"></div>
    <div id="filter-menu" :class="['filter-menu', { 'is-active': props.isActive }]" >
      <div class="filter-content">
        <div class="cross" @click="(e)=>emit('toggleMenu',e)">
          <!-- <div :class="['line', { toggle1: props.isActive }]"></div>
          <div :class="['line', { toggle2: props.isActive }]"></div> -->
        </div>
        <!-- <div class="kts-filter__close-filter"
        @click="toggleMenu"
        ><div class="kts-filter__close-btn"></div></div> -->
        <div class="filter-header">
          <h2 class="filter-heading">FILTER</h2>
          <span class="clear-filter-checkbox" @click="clearFilter()">CLEAR FILTER <a href=""></a></span>
        </div>

        <div class="filter-body">
          <div v-for="(filter, index) in menuItems" :key="index" :class="['filter-section', `filter-section-${index}`]" :style="filter?.isHidden ? { display: 'none' } : undefined">
            <h3 :class="['filter-section-title', { 'is-active': activeSections.includes(index) }]"  @click="toggleSection(index)" style="margin:0 !important">
             {{ filter.label ? filter.label : 'Price' }}
            </h3>
            <div :class="['filter-section-content', { 'is-active': activeSections.includes(index) }]">
              <template v-if="filter.label">
                <!-- <span v-if="index === 'category' && (['collection', 'occasions', 'price_range', 'metal_color', 'recipients', 'shop'].includes(currentTax))" class="select-all"></span>
                <span v-else class="select-all" @click="selectAll(filter, index)">Select all</span> -->

                <span
                  v-if="(filter.key === 'category' || filter.key === 'collection')
                    && ['collection', 'occasions', 'price_range', 'metal_color', 'recipients', 'shop', 'category'].includes(currentTax)"
                  class="select-all"
                ></span>

                <span
                  v-else
                  class="select-all"
                  @click="selectAll(filter, index)"
                  >
                  {{ index !== 'category' && index !== 'collection' ? 'Select all' : '' }}
                </span>
              </template>

              <template v-for="(sub, subIndex) in filter.subMenu" :key="sub.id">
                <label>
                  <input type="checkbox" :class="['filter-checkbox', sub.slug]" v-model="sub.isActive" @change="handleClick(index, sub)" />
                 <span style="margin:0;padding-top:3px;text-decoration:none;" v-html="sub.name"></span>
                </label>
              </template>

              <ListingProcess
                v-if="filter.max"
                v-model="rangeValues"
                :minPrice="minMaxPrice.min"
                :maxPrice="minMaxPrice.max"
                :currentPrice="currentPrice"
                :reset="resetSlidePrice"
                @setRangerPrice="setRangerPrice"
                @resetComplete="resetSlidePrice = false"
              />
            </div>
          </div>
        </div>
        <div class="view-product">
          <span @click="(e)=>emit('toggleMenu',e)">View {{ totalItems }} products</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import type { IProductFilterData, RelevantData } from '~/types/product-filter';
import {displaySgPrice} from "~/utils/displayPrice";
import ListingProcess from "./ListingProcess.vue";

const { productParams } = useProductState()
const menuItems = ref({});
const sorts = ['latest', 'price-low-to-high', 'price-high-to-low', 'bestsellers'];
const rangeValues = ref({ min: 10, max: 90 });
const currentPrice = ref([0, 0]);
const currentUrl = ref<string>('');
const resetSlidePrice = ref(false);
// const taxFilterSelected = ref<string>('');
const emit = defineEmits<{
  (e: 'toggleMenu'): void
  (e: 'updateParams'): void
  (e: 'closeMenuFilter'): void
  (e: 'filterRangerPrice', value: string[]): void
  (e: 'updateQueryFilter', value: Record<MenuFilterKey, string[]>, tax: string, selected: any): void,
  (e: 'clearQueryFilter', value: Record<MenuFilterKey, string[]>, clearAll: boolean): void
  (e: 'update', value: string[]): void
}>();
const runtimeConfig = useRuntimeConfig();
const selectedTax = ref(null)
const selectedItems = ref({})
const filters = ref<string[]>([]);
const isSkipChangeEvent = ref(false);
// Define the structure of a menu item
type MenuItem = {
  name: string;
  slug: string;
  isActive: boolean
};

// Define the structure of a menu category
type MenuCategory = {
  label: string;
  subMenu: MenuItem[];
  isHidden: boolean;
};

// Define the structure of the entire menu filter
type MenuFilter = {
  category: MenuCategory;
  collection: MenuCategory;
  material: MenuCategory;
  gemstone: MenuCategory;
  metal_color: MenuCategory;
  recipients: MenuCategory;
  price_type: MenuCategory;
  price: { min: string; max: string };
};

const props = defineProps({
  isActive: Boolean,
  menuFilter: {
    type: Object as PropType<MenuFilter>,
    required: true
  },
  currentTax: {
    type: String,
    required: true
  },
  lockedFilter: {
    type: Object
  },
  relevantFilter: {
    type: Object,
    required: true
  },
  currentParams: {
    type: Object
  },
  minMaxPrice: {
    type: Object
  },
  productParams: {
    type: Object
  },
  totalItems: {
    type: String,
    default: '0'
  }
});

type MenuFilterKey = keyof Omit<MenuFilter, 'price'>;

const queryFilter = ref<Partial<Record<MenuFilterKey, string[]>>>({});
const isActive = ref(false);
const activeSections = ref([]);
const allActives = ref(false);
const minVal = ref(0);
const maxVal = ref(0);
const menuFilters = ref({});

const position_list_filterr = () => {
  if (process.client) {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const screenWidth = window.innerWidth;
    const top_header = document.getElementById('masthead');
    const filter = document.getElementById('filter-menu');
    if (top_header && filter && screenWidth < 768)  {
      const height_header = top_header.offsetHeight;
      filter.style.top = scrollPosition > 0 ? '57px' : `${height_header}px`;
    }
  }
};


onMounted(() => {
  position_list_filterr();
  window.addEventListener('scroll', position_list_filterr);
  isActive.value = props.isActive;
  if (props.currentParams?.price) {
  const priceRange = props.currentParams?.price.split('@').map(Number);
  currentPrice.value = priceRange;

  //  minMaxPrice altdev
//   if (props.minMaxPrice) {
//   props.minMaxPrice.value = {
//     minPrice: priceRange[0],
//     maxPrice: priceRange[1]
//   }

// }
}
else {
  currentPrice.value = [0, 0]
}
  const setDefaultFilters: string[] = [];
  Object.entries(props.currentParams).forEach(([tax, item]) => {
    if (tax !== props.currentTax && tax !== 'default' && tax !== 'price' ) {
      try {
        const items = JSON.parse(item);
        if (Array.isArray(items)) {
          setDefaultFilters.push(...items);
        }
      } catch (error) {
        // console.error('Error parsing JSON:', error);
      }
    }
  });

  // console.log('setDefaultFilters', setDefaultFilters);

  filters.value = setDefaultFilters;

  // Initialize menuFilters with hardcoded price_type
  const hardcodedPriceType = {
    label: 'Price Type',
    subMenu: {
      nett_price: {
        name: 'Nett Price',
        slug: 'nett-price',
        isActive: false,
        isHidden: false
      },
      labour_cost: {
        name: 'Gold Weight Pricing',
        slug: 'labour-cost',
        isActive: false,
        isHidden: false
      }
    },
    isHidden: false
  };
  
  // Assign menuFilter excluding any price_type from API
  const filteredMenuFilter = { ...props.menuFilter };
  delete filteredMenuFilter.price_type;
  menuFilters.value = filteredMenuFilter;
  
  // Always set hardcoded price_type
  menuFilters.value.price_type = hardcodedPriceType;
  
  if( props.currentTax == 'shop' ) {
    currentUrl.value = `${runtimeConfig.public.BASE_URL}shop`;
  }else {
    if( typeof props.lockedFilter[props.currentTax] !== 'undefined' ) {
      const currentTerm = props.lockedFilter[props.currentTax][0];
      let taxSlug = props.currentTax;
      if( typeof slugTaxonomies[props.currentTax] !== 'undefined' ) {
        taxSlug = slugTaxonomies[props.currentTax];
      }
      currentUrl.value = `${runtimeConfig.public.BASE_URL}${taxSlug}/${currentTerm}`;
    }
  }
  menuFilterItems();
});
const setRangerPrice = (value: string[]) => {
  // console.log('min')
  emit('filterRangerPrice', value);
};

const menuKeys: (keyof Omit<MenuFilter, 'price'>)[] = ['category', 'collection', 'material', 'gemstone', 'metal_color', 'recipients', 'price_type'];

const slugTaxonomies = {
  category: 'product-category',
  metal_color: 'metal-color',
  recipients: 'product_recipients',
  price_type: 'cost'
};
// watch(() => props.menuFilter, () => {
//   menuFilterItems();
// })
const selectAll = (category: MenuCategory, key: MenuFilterKey) => {
  if (!category || !category.subMenu || typeof category.subMenu !== 'object') {
    // console.error('Invalid category or submenu');
    return;
  }
  selectedTax.value = key;
  selectedItems.value = category;

  const subMenuArray = Object.values(category.subMenu);
  const allActive = subMenuArray.every(sub => sub.isActive);
  allActives.value = !allActive;
  subMenuArray.forEach(sub => {
    sub.isActive = !allActive;
  });

  // console.log("\x1b[31m%s\x1b[0m", '============== selectAll ====================', menuItems.value);
  const queryUrl = Object.values(menuItems.value)
  .filter((menu) => !menu?.isHidden)
  .flatMap((menu) =>
    Object.values(menu.subMenu || {})
      .filter((sub) => sub.isActive && !sub?.isHidden)
      .map((sub) => sub.slug)
  )
  .join('/');
  // productParams.value[key] = queryUrl ? queryUrl : '';
//  console.log('allActive',allActive)
if(allActive){
  productParams.value[key] = '';
  Object.keys(menuItems.value[key].subMenu).forEach(subItemKey => {
    menuItems.value[key].subMenu[subItemKey].isActive = false;
  });
  // console.log('clerAll',menuItems.value);
}
else{
};
  // Always call updateQueryFilter to trigger API
  updateQueryFilter(key);
};


const clearFilter = (item: string = '') => {
  menuKeys.forEach(key => {
    if (menuItems.value[key] && menuItems.value[key].subMenu){
      Object.values(menuItems.value[key].subMenu).forEach(sub => {
        if (sub && 'isActive' in sub) {
          sub.isActive = false;
          filters.value = filters.value.filter(item => item !== sub.slug);
        }
      });
    }
  });
  const queryUrl = Object.values(menuItems.value)
    .flatMap((menu) =>
      Object.values(menu.subMenu || {})
        .filter((sub) => sub.isActive)
        .map((sub) => sub.slug)
    )
    .join('/');
    const cleanUrl = window.location.href.replace(/\/$/, '');
    const urlParts = cleanUrl.split('/');
    const sortFound = urlParts.find(part => sorts.includes(part));

    if (sortFound) {
      sortType.value = sortFound;
    }
  resetSlidePrice.value = true;
  if( typeof props.lockedFilter[props.currentTax] !== 'undefined' ) {
    const term = props.lockedFilter[props.currentTax][0];
    props.lockedFilter.value = {
      [props.currentTax]: [term]
    };

    let taxSlug = props.currentTax;
    if( typeof slugTaxonomies[props.currentTax] !== 'undefined' ) {
      taxSlug = slugTaxonomies[props.currentTax];
    }
  }

  selectedTax.value = null;
  selectedItems.value = {};
  if (props.productParams) {
    props.productParams.price = '';
    if(props.productParams.default == 'shop'){
      props.productParams.category = '';
      props.productParams.collection = '';
      props.productParams.gemstone = '';
      props.productParams.material = '';
      props.productParams.metal_color = '';
      props.productParams.recipients = '';
    }
  }

  queryFilter.value = {};

  // Remove isactive class from cart items
  if (process.client) {
    setTimeout(() => {
      document.querySelectorAll('.listing-content .listing-collections-custom .cart-item').forEach((item) => {
        item.classList.remove('isactive');
      });
    }, 300);
  }

  emit("clearQueryFilter", props.lockedFilter.value, true);
  emit("updateParams");

};
const toggleSection = (section: any) => {
  const index:any = activeSections.value.indexOf(section);
  if (index === -1) {
    activeSections.value.push(section);
  } else {
    activeSections.value.splice(index, 1);
  }
};

const sortType = ref('');
const removeSort = (url: string): string => {
  try {
    const cleanUrl = url.replace(/\/$/, '');
    const urlParts = cleanUrl.split('/');
    const sortFound = urlParts.find(part => sorts.includes(part));

    if (!sortFound) {
      return url;
    }

    sortType.value = '/' + sortFound;
    const filteredParts = urlParts.filter(part => !sorts.includes(part));
    return filteredParts.join('/') + '/';

  } catch (error) {
    return url;
  }
};



const handleClick = (index: MenuFilterKey, item: MenuItem ) => {
  // Skip if this is a secondary @change from mutating another checkbox
  if (isSkipChangeEvent.value) {
    return;
  }
  
  // if(index === 'category' && props.currentTax == 'collection' ) {
   if(index === 'category' && (['collection', 'occasions', 'price_range', 'metal_color', 'recipients', 'shop'].includes(props.currentTax)) ) {
    // Set flag to prevent @change from firing again
    isSkipChangeEvent.value = true;
    
    Object.values(menuItems.value[index].subMenu).forEach(sub => {
      if (sub.slug !== item.slug) {
        sub.isActive = false;
      }
    });
    
    // Reset flag after mutations
    isSkipChangeEvent.value = false;
    
    const allCheckbox = document.querySelector('#cat-product_cat_all');
    if (allCheckbox) {
      allCheckbox.checked = false;
    }
  }
  // if (props.productParams.price) {
  //   //props.productParams.price = '';
  //   //emit("updateParams");
  // }

  if (selectedTax.value === null || selectedTax.value === index) {
    selectedTax.value = index

    if( Object.keys(selectedItems.value).length == 0 ) {
      selectedItems.value = menuItems.value[index];
    }
  } else {
    selectedTax.value = index
    selectedItems.value = menuItems.value[index];
  }
  if (item.isActive) {
    filters.value.push(item.slug);
  } else {

    const index = filters.value.indexOf(item.slug);
    if (index !== -1) {
      filters.value.splice(index, 1);
    }
  }

  updateQueryFilter(index,item.slug);
  emit("update", [item.slug]);
};

const responseFilters = (filters: IProductFilterData, relevant: RelevantData) => {
  const filteredResponseFilters: IProductFilterData = {};
  Object.entries(filters).forEach(([key, item]) => {
    // CRITICAL: Skip price_type from API - we always use hardcoded price_type only
    // This check must happen FIRST before any other logic
    if (key === 'price_type') {
      return;
    }
    
    if (item.subMenu !== undefined ) {
      if( key == props.currentTax ) {
        item.isHidden = true;
      }else {
        if( item?.isHidden ) {
          item.isHidden = false;
        }
      }
      const filteredSubMenu: { [key: string]: any } = {};
      if (relevant && relevant[key]) {
        Object.entries(item.subMenu).forEach(([subKey, subItem]) => {
          if (props?.lockedFilter?.[key]) {
            const currentParamsItem = props.lockedFilter[key];
            if (currentParamsItem.includes(subKey)) {
              subItem.isActive = true;
            }
          };
          if (relevant[key].includes(subKey)) {
            filteredSubMenu[subKey] = subItem;
          }

        });
      }
      if (Object.keys(filteredSubMenu).length > 0) {
        if( ! Object.keys(selectedItems.value).length || selectedTax.value !== key ) {
          filteredResponseFilters[key] = {
            ...(<object>item),
            subMenu: filteredSubMenu
          };
        }else {
          if( selectedTax.value === key ) {
            filteredResponseFilters[key] = selectedItems.value;
          }

        }
      }else {
        if( selectedTax.value === key && key !== 'price' && key !== 'price_type' ) {
          filteredResponseFilters[key] = selectedItems.value;
        }

      }
    } else {
      // Ensure price_type never gets added here
      if (key !== 'price_type') {
        filteredResponseFilters[key] = item;
      }
    }
  });
  
  // Triple-check: ensure price_type was NOT added from any path
  if (filteredResponseFilters.price_type) {
    delete filteredResponseFilters.price_type;
  }
  
  return filteredResponseFilters;
}

const addIndex = (result) => {

  Object.keys(result).forEach((key) => {
    const item = result[key];
    if ('subMenu' in item && item.subMenu) {
      let index = 0;
      Object.keys(item.subMenu).forEach((subItem) => {
        item.subMenu[subItem].index = index;
        index++;
      });
    }
  });

  return result;
}

const menuFilterItems = () => {
  // Preserve the active state of price_type from previous state BEFORE processing
  const prevPriceTypeState: { [key: string]: boolean } = {};
  if (menuItems.value.price_type && menuItems.value.price_type.subMenu) {
    Object.keys(menuItems.value.price_type.subMenu).forEach(key => {
      if (menuItems.value.price_type.subMenu[key]) {
        prevPriceTypeState[key] = menuItems.value.price_type.subMenu[key].isActive || false;
      }
    });
  }
  
  // Filter out price_type from props.menuFilter BEFORE processing
  const menuFilterWithoutPriceType: any = {};
  Object.entries(props.menuFilter).forEach(([key, value]) => {
    if (key !== 'price_type') {
      menuFilterWithoutPriceType[key] = value;
    }
  });
  
  // Process filtered menu (without price_type from API)
  const filterMenuItems = responseFilters(menuFilterWithoutPriceType, props.relevantFilter);
  
  // FINAL SAFETY: Remove any price_type that somehow made it through
  delete filterMenuItems.price_type;
  
  // Create fresh hardcoded price_type with preserved active states
  let freshPriceType: any = null;
  if (menuFilters.value.price_type) {
    freshPriceType = JSON.parse(JSON.stringify(menuFilters.value.price_type));
    
    // Apply preserved active states
    if (Object.keys(prevPriceTypeState).length > 0) {
      Object.keys(freshPriceType.subMenu).forEach(key => {
        if (typeof prevPriceTypeState[key] !== 'undefined') {
          freshPriceType.subMenu[key].isActive = prevPriceTypeState[key];
        }
      });
    }
  }
  
  // Build sortedItems by menuKeys order
  const sortedItems: any = {};
  menuKeys.forEach(key => {
    if (key === 'price_type') {
      // Only add hardcoded price_type here, never from API
      if (freshPriceType) {
        sortedItems.price_type = freshPriceType;
      }
    } else if (filterMenuItems[key]) {
      sortedItems[key] = filterMenuItems[key];
    }
  });
  
  // Add any remaining keys (price, etc) - NEVER add price_type here
  Object.keys(filterMenuItems).forEach(key => {
    if (key !== 'price_type' && !sortedItems[key]) {
      sortedItems[key] = filterMenuItems[key];
    }
  });
  
  // PARANOIA CHECK: Count price_type occurrences
  let priceTypeCount = 0;
  Object.keys(sortedItems).forEach(key => {
    if (key === 'price_type') {
      priceTypeCount++;
    }
  });
  
  // If somehow we have multiple price_type entries, rebuild clean version
  if (priceTypeCount > 1) {
    const cleanedItems: any = {};
    Object.entries(sortedItems).forEach(([key, value]) => {
      // Skip any duplicate price_type
      if (key === 'price_type' && cleanedItems.price_type) {
        return;
      }
      cleanedItems[key] = value;
    });
    menuItems.value = addIndex(cleanedItems);
    return;
  }
  
  menuItems.value = addIndex(sortedItems);
}

watch(
  () => props.relevantFilter,
  (newRelevantFilter) => {
    menuFilterItems();
  },
  { deep: true, immediate: true }
);


const updateQueryFilter = (index: MenuFilterKey, selected?: any) => {
  // Get current filter from menuItems (updated by v-model)
  const currentFilter = menuItems.value[index];
  let activeSubMenu = [];
  
  if (currentFilter && currentFilter.subMenu) {
    activeSubMenu = Object.values(currentFilter.subMenu)
      .filter(sub => 'isActive' in sub && sub.isActive)
      .map(sub => sub.slug);
  }
  
  if (activeSubMenu.length) {
    queryFilter.value[index] = activeSubMenu;
  } else {
    delete queryFilter.value[index];
  }
  
  // Map price_type to cost for query parameter
  const queryFilterToEmit = { ...queryFilter.value };
  if (queryFilterToEmit.price_type) {
    queryFilterToEmit.cost = queryFilterToEmit.price_type;
    delete queryFilterToEmit.price_type;
  }
  
  emit("updateQueryFilter", queryFilterToEmit, selectedTax.value, selectedItems.value, selected);
};

</script>

<style lang="scss">
.filter-section-recipients {display: none}
.filter-section-price_type {
  /* Price Type filter styling */
}
</style>